<template>
  <div id="accountManage">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="角色">
        <el-select style="width: 200px" size="mini" v-model="searchForm.roleId" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.roleCn"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生效状态">
        <el-select style="width: 100px" size="mini" v-model="searchForm.isWork" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in workStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="mini"
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="searchForm.keyWords">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
        <el-button type="primary" size="mini" @click="onCreate">添加账号</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="loginName" label="用户名"></el-table-column>
      <el-table-column prop="roleId" label="角色" :formatter="roleFormatter"></el-table-column>
      <el-table-column :prop="level == 'A'?'companyId':'deptId'" :label="level == 'A' ? '所属单位':'所属部门'" :formatter="companyFormatter"></el-table-column>
      <el-table-column prop="email" label="电子邮箱" width="180"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="isWork" label="生效状态">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isWork == '1'"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="isLoginControlChange(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editAccount(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteAccount(scope.row)"
            type="text"
            size="small">
            删除
          </el-button>
          <!--<el-button-->
            <!--@click.native.prevent="uploadHeadPic(scope.row)"-->
            <!--type="text"-->
            <!--size="small">-->
            <!--{{scope.row.headPic ? "修改" : "上传"}}头像-->
          <!--</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="accountForm" :model="accountForm" :rules="rules" label-width="120px" style="margin-right: 40px">
        <el-form-item label="登录名称" prop="loginName">
          <el-input v-model="accountForm.loginName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="accountForm.password" type="password" show-password></el-input>
          <!-- <el-button v-if="action == 'edit'"
            @click="changePasswordFun"
            type="text"
            size="small">
            {{changePassword ?"保存":"修改"}}
          </el-button> -->
        </el-form-item>
        <el-form-item label="姓名" prop="actualName">
          <el-input v-model="accountForm.actualName"></el-input>
        </el-form-item>
        <el-form-item label="头像">
          <!--<img style="width: 40px;" :src="headPicImg ? headPicImg : require('../assets/person.png')">-->
          <el-upload
            ref="upload"
            action="/api/sysConfig/upload"
            list-type="picture-card"
            :limit="1"
            :on-success="uploadHeadPicSuccess"
            :on-remove="removeHeadPic"
            :file-list="headPicFile">
            <i class="el-icon-plus icon-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="level == 'A'?'所属单位':'所属部门'" prop="companyId">
          <el-select style="width: 100%" v-model="accountForm.companyId" placeholder="请选择" @change="companyIdChange">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="level == 'A'?item.companyName:item.deptName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="accountForm.email"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="accountForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select style="width: 100%" v-model="accountForm.roleId" placeholder="请选择">
            <el-option
              v-for="item in roleByCompanyList"
              :key="item.id"
              :label="item.roleCn"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!--<el-dialog-->
      <!--title="上传头像"-->
      <!--:visible.sync="uploadHeadPicVisible"-->
      <!--width="40%"-->
      <!--:before-close="handleHeadPicClose">-->
      <!--<el-upload-->
        <!--ref="upload"-->
        <!--action="/upload/sysConfig/upload"-->
        <!--list-type="picture-card"-->
        <!--:limit="1"-->
        <!--:on-success="uploadHeadPicSuccess"-->
        <!--:on-remove="removeHeadPic"-->
        <!--:file-list="headPicFile">-->
        <!--<i class="el-icon-plus icon-uploader-icon"></i>-->
      <!--</el-upload>-->
      <!--<span slot="footer" class="dialog-footer">-->
        <!--<el-button @click="handleHeadPicClose">取 消</el-button>-->
        <!--<el-button type="primary" @click="onHeadPicFileSubmit">确 定</el-button>-->
      <!--</span>-->
    <!--</el-dialog>-->
  </div>
</template>

<script>
  import utils from '../utils/utils'
  import axios from 'axios'
  export default {
    name: "account-manage",
    data(){
      return{
        workStatus:[{
          label:"是",
          value:"1"
        },{
          label:"否",
          value:"0"
        }],
        searchForm:{
          isWork:null,
          roleId:null,
          keyWords:""
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        },
        dialogTitle:"",
        dialogVisible:false,
        action:"",
        roleList:[],
        companyList:[],
        level:"",
        accountForm:{
          loginName:"",
          password:"",
          actualName:"",
          companyId:null,
          email:"",
          phone:"",
          roleId:null
        },
        rules:{
          loginName:[
            {required: true, message: '请输入登录名称', trigger: 'blur'},
            {pattern: /^[a-zA-Z0-9]{4,12}$/, message: '请输入4-12为数字或者字母组合', trigger: ['blur', 'change']}
            ],
          password:[
            {required: true, message: '请输入密码', trigger: 'blur'},
            { min: 8, message: "密码长度至少8个字符", trigger: "blur" },
            {pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]/, message: '密码应包括大写字母，小写字母，数字，特殊符号中任意3项', trigger: ['blur', 'change']}],
          // actualName:[{required: true, message: '请输入姓名', trigger: 'blur'}],
          companyId:[{required: true, message: '请选择所属单位', trigger: 'change'}],
          email:[
            // {required: true, message: '请输入电子邮箱', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
            ],
          phone:[
            // {required: true, message: '请输入手机号码', trigger: 'blur'},
            {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
            ],
          roleId:[{required: true, message: '请选择角色', trigger: 'change'}],
          actualName:[{ min: 0, max: 10, message: "长度在 0 到 10 个字符", trigger: "blur" }]
        },
        accountId:null,
        roleByCompanyList:[],
        uploadHeadPicVisible:false,
        changePassword:false,
        headPicImg:"",
        headPicFile:[],
      }
    },
    created(){
      this.level = this.$route.query.level;
      this.getCompanyAllA()
      this.getRoleAList()
      this.getData()
    },
    methods:{
      getCompanyAllA(){
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A" ? "/api/platform/queryCompanyAllA":"/api/accountManage/queryDeptBAll",
          callback:(res => {
            this.companyList = res.data.list;
          })
        })
      },
      getRoleAList(){
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A" ? "/api/platform/queryRoleAllA":"/api/accountManage/queryRoleBAll",
          callback:(res => {
            this.roleList = res.data.list;
          })
        })
      },
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        let success = (response) => {
          loading.close();
          if(response.data.code === 0){
            this.pageInfo.total = response.data.total;
            this.tableData = response.data.list;
            if(this.tableData){
              this.tableData.map(t=>{
                if(!t.headPic){
                  t.headPic = 'http://pic.mumetech.com/1606442431036_头像.png';
                }
              })
            }
          }
        }
        utils.axiosMethods({
          method:"POST",
          url:this.level == "A" ? "/api/platform/queryAccountA" : "/api/accountManage/queryAccountB",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize
          },
          data:{
            isWork:this.searchForm.isWork,
            roleId:this.searchForm.roleId,
            keyWords:this.searchForm.keyWords
          },
          callback:success,
          catch:(err => {
            loading.close()
          })
        })
      },
      onSearch(){
        this.getData()
      },
      deleteAccount(row){
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A"?"/api/platform/deleteAccountA":"/api/accountManage/deleteAccountB",
          params: {
            id: row.id,
          },
          callback: (res => {
            this.$message.success("删除成功");
            this.getData();
          })
        })
      },
      onCreate(){
        this.dialogTitle = "添加账号"
        this.dialogVisible = true;
        this.action = "add"
      },
      onSubmit(){
        //验证表单
        this.$refs["accountForm"].validate((valid) => {
          if(valid){
            let url,formData;
            formData = {
              loginName:this.accountForm.loginName,
              actualName:this.accountForm.actualName,
              email:this.accountForm.email,
              phone:this.accountForm.phone,
              roleId:this.accountForm.roleId,
              headPic:this.headPicImg,
              password:this.accountForm.password
            }
            if(!formData.headPic||formData.headPic==""){
              formData.headPic='http://pic.mumetech.com/1606442431036_头像.png';
            }
            if(this.level == "A"){
              formData.companyId = this.accountForm.companyId
            }else{
              formData.deptId = this.accountForm.companyId
            }
            if(this.action == "add"){
              if(this.level == "A"){
                url = "/api/platform/insertAccountA"
              }else{
                url = "/api/accountManage/insertAccountB"
              }
            }else{
              if(this.level == "A"){
                url = "/api/platform/updateAccountA"
              }else {
                url = "/api/accountManage/updateAccountB"
              }
              formData.id = this.accountId
            }
            utils.axiosMethods({
              method: "POST",
              url: url,
              data:formData,
              callback:(res => {
                if(res.data.code == 0){
                  this.dialogVisible = false;
                  if(this.action == "add"){
                    this.$message.success("创建成功");
                  }else{
                    this.$message.success("修改成功");
                  }
                  this.getData();
                }else{
                  this.$message.error(res.data.msg)
                }
              })
            })
          }
        })
      },
      isLoginControlChange(row){
        let isWork = row.isWork == '1' ? '0':'1';
        utils.axiosMethods({
          method: "GET",
          url: this.level == "A" ? "/api/platform/changeLoginControl":"/api/accountManage/changeLoginControl",
          params:{
            id:row.id,
            isWork:isWork
          },
          callback:(res => {
            this.$message.success("操作成功");
            this.getData();
          })
        })
      },
      handleClose(){
        this.dialogVisible = false;
        this.accountForm = {
          loginName:"",
          password:"",
          actualName:"",
          companyId:null,
          email:"",
          phone:"",
          roleId:null
        };
        this.accountId = null;
        this.roleByCompanyList = [];
        this.changePassword = false;
        this.headPicImg = "";
        this.headPicFile = [];
      },
      editAccount(row){
        this.dialogTitle = "编辑"
        this.dialogVisible = true;
        this.action = "edit"
        this.accountForm = {
          loginName:row.loginName,
          password:row.password,
          actualName:row.actualName,
          companyId:this.level == 'A' ? row.companyId : row.deptId,
          email:row.email,
          phone:row.phone,
          roleId:row.roleId
        };
        let val = this.level == 'A' ? row.companyId : row.deptId
        this.companyIdChange(val);
        this.accountId = row.id;
        // if(row.headPic && row.headPic.indexOf("http://")==-1){
        //   row.headPic = 'http:/pic.mumetech.com' + row.headPic;
        // }
        this.headPicImg = row.headPic;
        this.headPicFile = [{
          url:row.headPic
        }]
      },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      roleFormatter(row, column, cellValue, index){
        if(this.roleList.length > 0){
          const roleList = this.roleList.filter(role => role.id == cellValue);
          return roleList.length == 1 ? roleList[0].roleCn : ""
        }else{
          return;
        }
      },
      companyFormatter(row, column, cellValue, index){
        if(this.level == "A"){
          const list = this.companyList.filter(company => company.id == cellValue);
          return list.length == 1 ? list[0].companyName:""
        }else{
          const list = this.companyList.filter(dept => dept.id == cellValue);
          return list.length == 1 ? list[0].deptName : ""
        }

      },
      companyIdChange(val){
        if(val){
          utils.axiosMethods({
            method: "GET",
            url: this.level == "A"?"/api/platform/queryRoleAByCompanyId":"/api/accountManage/queryRoleBByDeptId",
            params:this.level == "A"?{
              companyId:val.toString(),
            }:{
              deptId:val,
            },
            callback:(res => {
              this.roleByCompanyList = res.data.list;
            })
          })
        }else{
          this.roleByCompanyList = []
        }
      },
      changePasswordFun(){
        this.$refs.accountForm.validateField('password',(message => {
          if(!message){
            this.changePassword = !this.changePassword;
            if(!this.changePassword){
              utils.axiosMethods({
                method: "POST",
                url:this.level == "A" ? "/api/platform/changePassword":"/api/accountManage/changePassword",
                data:{
                  id:this.accountId,
                  loginname:this.accountForm.loginName,
                  password:this.accountForm.password
                },
                callback:(res => {
                  this.$message.success("密码修改成功");
                  this.getData()
                })
              })
            }
           }
        }))
      },
      // uploadHeadPic(row){
      //   this.uploadHeadPicVisible = true
      //   this.accountId = row.id;
      //   this.headPicImg = row.headPic;
      //   this.headPicFile = row.headPic?[{url:row.headPic}]:[];
      // },
      // handleHeadPicClose(){
      //   this.uploadHeadPicVisible = false
      //   this.headPicImg = ""
      //   this.headPicFile = []
      //   this.accountId = null
      // },
      // onHeadPicFileSubmit(){
      //   let formData = new FormData();
      //   formData.append("headPic", this.headPicImg);
      //   formData.append("id", this.accountId);
      //   axios.post(this.level == "A"?"/api/platform/uploadHeadPic":"/api/accountManage/uploadHeadPic", formData)
      //     .then( response=> {
      //       if(response.data.code == 0){
      //         this.handleHeadPicClose();
      //         this.$message({
      //           message: '头像上传成功',
      //           type: 'success'
      //         });
      //         this.getData();
      //       }else{
      //         this.$message({
      //           message: response.data.msg,
      //           type: 'error'
      //         });
      //       }
      //     })
      //     .catch(error => {
      //       this.$message({
      //         message: error,
      //         type: 'error'
      //       });
      //     });
      // },
      uploadHeadPicSuccess(response,file,fileList){
        let headPicImg = [];
        fileList.forEach(item => {
          headPicImg.push(item.response);
        })
        this.headPicImg = headPicImg.join(";");
      },
      removeHeadPic(file,fileList){
        this.headPicImg = "";
        // 删除原有图片
        utils.axiosMethods({
          method: "POST",
          url: "/upload/sysConfig/deletefile",
          params: {
            url:file.response?file.response:file.url
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #accountManage{
    .block{
      float: right;
      margin-top: 20px;
    }
  }
</style>
<style lang="less">
  #accountManage{
    .icon-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .icon-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .icon-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .icon-img {
      width: 60px;
      height: 60px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/accountManage.vue